<div 
  class="pin-button"
  (click)="handleClick()"
  [ngClass]="{
    'pin-button--selected': selected,
    'pin-button--disabled': disabled,
    'pin-button--small': size === 'small',
    'pin-button--ghost': type === 'ghost',
    'pin-button--outline': type === 'outline',
    'pin-button--row': direction === 'row'
  }">
  <div class="pin-button__pin">
    <!-- Icon -->
    <app-icon [icon]="icon" *ngIf="icon"></app-icon>
    
    <!-- Image -->
    <span *ngIf="src" [style.backgroundImage]="'url(' + src + ')'" class="pin-button__image"></span>

    <ng-content></ng-content>
  </div>

  <div class="pin-button__label" *ngIf="label">
    {{ label }}
  </div>
</div>